import { service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router';
import type SessionContextService from '../services/session-context';
import type SessionService from '../services/session';
import pageTitle from 'ember-page-title/helpers/page-title';
import { t } from 'ember-intl';
import { NotificationsContainer } from 'tio-ui/components/notifications';

export default class ApplicationRouteComponent extends Component {
  @service declare router: RouterService;
  @service declare session: SessionService;
  @service declare sessionContext: SessionContextService;

  get isFullyAuthenticatedPage() {
    return this.sessionContext.isFullyAuthenticated;
  }

  <template>
    {{pageTitle (t "application_page_title")}}

    {{outlet}}

    <NotificationsContainer @placement="top-right" />

    {{! Global portal target for Drawers and overlays to avoid parent portal nesting issues }}
    <div id="tio-drawer-target"></div>
  </template>
}
